export default __webpack_public_path__ + "static/media/hero_mobile_img.96636e56.png";